import React, { createContext, useContext, useState, useEffect } from 'react';

const AdminAuthContext = createContext(null);

const ADMIN_USER = 'Durval';
const ADMIN_PASS = 'universosg123';
const STORAGE_KEY = 'admin_autenticado';

export function AdminAuthProvider({ children }) {
  const [autenticado, setAutenticado] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  });

  const login = (usuario, senha) => {
    if (usuario === ADMIN_USER && senha === ADMIN_PASS) {
      localStorage.setItem(STORAGE_KEY, 'true');
      setAutenticado(true);
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY);
    setAutenticado(false);
  };

  return (
    <AdminAuthContext.Provider value={{ autenticado, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}
